import React from 'react'
import FooterContent from './footer-content'

const StorboltFooter = () => {

    return (
        <FooterContent>
            <div className='flex flex-col gap-1 md:flex-row justify-between text-default-500 text-center text-[13px]'>
                <div>
                    COPYRIGHT &copy; {new Date().getFullYear()} Storbolt, All rights Reserved
                </div>
                <div>
                    Made by{" "}
                    <a
                        href="https://ocnyamali.com"
                        target="_blank"
                        className="text-primary font-semibold"
                        rel="noreferrer"
                    >
                        OC
                    </a>
                </div>
            </div>
        </FooterContent>

    )
}

export default StorboltFooter